module.exports = __webpack_public_path__ + "static/media/search-dark.99e3bed0.svg";